import axios from 'axios';
import { showToastDefault } from '../components/EpToaster';

const httpService = () => {
  const get = async (url, data, hasSuccessToaster, toasterTitle, toasterDescription) => {
    try {
      const response = await axios.get(url, { params: data });
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response.data;
    } catch (error) {
      return showToastDefault(error, toasterTitle, toasterDescription);
    }
  };

  const post = async (url, data, hasSuccessToaster, toasterTitle, toasterDescription) => {
    try {
      const response = await axios.post(url, { params: data });
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response.data;
    } catch (error) {
      return showToastDefault(error, toasterTitle, toasterDescription);
    }
  };

  const put = async (url, data, hasSuccessToaster, toasterTitle, toasterDescription) => {
    try {
      const response = await axios.put(url, { params: data });
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response.data;
    } catch (error) {
      return showToastDefault(error, toasterTitle, toasterDescription);
    }
  };

  const remove = async (url, data, hasSuccessToaster, toasterTitle, toasterDescription) => {
    try {
      const response = await axios.delete(url, { params: data });
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response.data;
    } catch (error) {
      return showToastDefault(error, toasterTitle, toasterDescription);
    }
  };

  return {
    get, post, put, remove,
  };
};

export default httpService;
